import { Tab, type TabProps } from 'react-admin';
import SummaryDetails from '@/pages/components/SummaryDetails';
import useController from './useController';

const SummaryTab = (props: Partial<TabProps>) => {
  const controller = useController();

  return (
    <Tab label="info" {...props}>
      <SummaryDetails controller={controller} />
    </Tab>
  );
};

export default SummaryTab;
